<template>
  <modal back="product" :title="$t('titles.changeColor')">
    <color-picker
      :colors="colors"
      :selected-color="selectedColor"
      @selectColor="handleSelection"
    />
  </modal>
</template>
<script>
import ColorPicker from '../../components/ColorPicker.vue';
import Modal from '../../components/Modal.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import { GETTER_PRODUCT_DIFFERENT_COLOR } from '../../store/modules/product/getters';

export default {
  name: 'ProductColor',
  components: {
    Modal,
    ColorPicker
  },
  mixins: [TrackingMixin],
  computed: {
    colors() {
      return this.$store.getters['product/availableColors'];
    },
    selectedColor() {
      return this.$store.getters['product/selectedColor'];
    }
  },
  methods: {
    handleSelection({ id }) {
      this.$router.push({
        params: {
          articleNumber: this.$store.getters[GETTER_PRODUCT_DIFFERENT_COLOR](id)
        }
      });
      this.trackEvent({
        action: 'Product_ChangeColor',
        label: `${this.selectedColor}:${id}`
      });
      this.$root.$emit('reset-navigation');
    }
  }
};
</script>
